// Option B : plus de saisie de clé API. La connexion au tableau de bord B2B passe par le
// portail (e-mail + mot de passe), qui y revient ensuite.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { URL_CONNEXION_B2B } from '../services/b2bApi';

export default function B2BLogin() {
  return <Navigate to={URL_CONNEXION_B2B} replace />;
}
